<script setup lang="ts">
defineProps({
  modelValue: {
    type: Boolean,
    required: true,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
})

const emit = defineEmits(['update:modelValue'])

const onUpdate = (value: boolean) => emit('update:modelValue', value)
</script>

<template>
  <v-tooltip
    :model-value="modelValue"
    v-bind="$attrs"
    location-strategy="connected"
    z-index="1"
    :disabled="disabled"
    @update:model-value="onUpdate"
  >
    <template #activator="{ props }">
      <div v-bind="props">
        <slot name="activator" />
      </div>
    </template>

    <slot name="content" />
  </v-tooltip>
</template>

<style lang="scss" scoped>
.v-overlay {
  z-index: 3000 !important;
}
.v-overlay--absolute {
  left: -1000px !important;
}

:deep(.v-overlay__content) {
  width: max-content !important;
  max-width: 250px !important;
  padding: 16px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: $white !important;
  word-wrap: break-word !important;
  background-color: $black !important;
  border-radius: 16px !important;
}
</style>
